import { render } from "./index.vue?vue&type=template&id=17754a4b&scoped=true&bindings={}"
import script from "./Spotify-api.js?vue&type=script&lang=js"
export * from "./Spotify-api.js?vue&type=script&lang=js"

import "./Spotify-api.scss?vue&type=style&index=0&id=17754a4b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17754a4b"

export default script